<template>
	<sf-modal-layout size="xxl" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<pqy-cpny-pop-search-view ref="PqyCpnyPopSearchView" :scrId="scrId" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pqy-cpny-pop-view ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/PqyCpnyPopup/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';

import PqyCpnyPopSearchView from './Content/Search/PqyCpnyPopSearchView.vue';
import PqyCpnyPopView from './Content/Table/PqyCpnyPopView.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PqyCpnyPopSearchView, PqyCpnyPopView },
	data() {
		return {
			show: false,
			title: 'Company Search Popup',
			propCpnyCd: '',
			propCpnyScn: '' //(10:생산업체, 20:납품업체, 90:htwo)
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			try {
				this.show = true;
				if (param) {
					this.propCpnyCd = param.cpnyCd;
					this.propCpnyScn = param.cpnyScn; //(10:생산업체, 20:납품업체, 90:htwo)
					this.setSearchParam_({ key: 'cpnyCd', value: param.cpnyCd });
					this.setSearchParam_({ key: 'cpnyScn', value: param.cpnyScn });
					this.setSearchParam_({ key: 'useYn', value: 'Y' });

					if (param.cpnyScn === '10') {
						this.title = this.getMessage_('QWCC001718');
					} else if (param.cpnyScn === '20') {
						this.title = this.getMessage_('QWCC001717');
					}
				}
				this.reload();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		close() {
			// debugger;
			this.setSearchParam_({ key: 'cpnyCd', value: '' });
			this.setSearchParam_({ key: 'cpnyScn', value: '' });
			this.setSearchParam_({ key: 'useYn', value: '' });

			this.$refs.PqyCpnyPopSearchView.reset();
			this.show = false;
		},
		reload(currentPage = 1, pageUnit = 30) {
			if (this.$refs.PqyCpnyPopSearchView) {
				this.$refs.PqyCpnyPopSearchView.searchList(currentPage, pageUnit);
			}
		},
		// userGbn은 하나의 Form에 사용자 찾기가 2건이 필요할 경우 해당 값을 셋팅한다.
		sendData(sendParam) {
			this.$emit('SendData', sendParam);
			this.close();
		}
	}
};
</script>

<style></style>
